import { createContext } from "react";

/** DOM node inside the salon's sticky "Editando ..." bar where a tab can portal its own actions. */
export const BarraAccionesContext = createContext(null);
